import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { notification,Modal, Form } from 'antd';
import styles from './Footer.scss';
import classNames from 'classnames/bind';
import "./InfoModal.scss";

const cx = classNames.bind(styles);

@inject('commonStore')

@observer
class InfoModal extends Component {
  onModpw = (values) => {
    if (values.cePwNew !== values.cePwNew1) {
      notification.warning({placement: 'bottomLeft', message: `변경 비밀번호가 같지 않습니다..`, duration: 2});
      return false;
    } else {
      this.props.commonStore.modPwInfo(values.cePw, values.cePwNew);
    }
};

render() {
  const { modalOpen, sessionLoginInfo } = this.props;
  const ModalForm: React.FC<ModalFormProps> = ({ visible }) => {
    const [form] = Form.useForm();
  
    const onCancel = () => {
      form.resetFields();
      this.props.modalClose();
    };
  
    return (
      <Modal  
        width={1000}
        height={800}
        title="개인정보처리방침"
        closable={false}
        visible={visible}
        onCancel={onCancel}
        footer={null}
      >
      

      <div className = {cx('detail')}>
        <p>㈜유진에스앤에이는(이하"회사"는) 고객님의 개인정보를 중요시하며, " 정보통신망 이용촉진 및 정보보호"에 관한 법률을 준수하고 있습니다. </p>
        <p>회사는 개인정보취급방침을 통하여 고객님께서 제공하시는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며, 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다. </p>
        <br/>
        <p id='pick'>■ 수집하는 개인정보 항목 및 수집방법</p>
        <p>가. 수집하는 개인정보의 항목</p>
        <p>• 회사는 서비스 신청등을 위해 아래와 같은 개인정보를 수집하고 있습니다.</p>
        <p>서비스 신청시 : 주소, 연락처, 결제정보</p>
        <p>• 서비스 이용 과정이나 사업 처리 과정에서 서비스이용기록, 접속로그, 쿠키, 접속IP, 결제기록, 불량이용 기록이 생성되어 수집될 수있습니다.</p>
        <br/>
        <p>나. 수집방법</p>
        <p>• 홈페이지, 서면양식, 배송요청, 전화, 생성 정보 수집 툴을 통한 수집</p>
        <br/>
        <p id='pick'>■ 개인정보의 수집 및 이용목적</p>
        <p>회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.</p>
        <p>• 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산</p>
        <p>콘텐츠 제공, 구매 및 요금 결제, 물품배송 또는 청구지 등 발송, 금융거래 본인 인증 및 금융 서비스</p>
        <p>• 회원 관리</p>
        <p>회원제 서비스 이용에 따른 본인확인, 개인 식별, 불량회원의 부정 이용 방지와 비인가 사용 방지</p>
        <p>• 마케팅 및 광고 활용</p>
        <p>고객 맞춤형 서비스 제공, 서비스 이용 통계 관리 목적으로 개인정보를 처리 </p>
        <br/>
        <p id='pick'>■ 개인정보의 보유 및 이용기간</p>
        <p>원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다. 단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존합니다.</p>
        <br/>
        <p>가. 회사 내부방침에 의한 정보보유 사유</p>
        <p>회원이 탈퇴한 경우에도 불량회원의 부정한 이용의 재발을 방지, 분쟁해결 및 수사기관의 요청에 따른 협조를 위하여 이용계약 해지일로부터 3년간 회원의 정보를 보유할 수 있습니다.</p>
        <br/>
        <p>나. 관련 법령에 의한 정보보유 사유</p>
        <p>전자상거래 등에서의 소비자보호에 과한 법률 등 관계법령의 규정에 의하여 보존할 필요가 있는 경우 회사는 아래와 같이 관계법령에 정한 일정한 기간 동안 회원정보를 보관합니다. </p>
        <p>• 계약 또는 청약철회 등에 관한 기록</p>
        <p>보존이유 : 전자상거래 등에서의 소비자보호에 관한 법률</p>
        <p>보존기간 : 5년</p>
        <p>• 대금 결제 및 재화 등의 공급에 관한 기록</p>
        <p>보존이유 : 전자상거래 등에서의 소비자보호에 관한 법률</p>
        <p>보존기간 : 5년</p>
        <p>• 소비자 불만 또는 분쟁처리에 관한 기록</p>
        <p>보존이유 : 전자상거래 등에서의 소비자보호에 관한 법률</p>
        <p>보존기간 : 3년</p>
        <p>• 로그 기록</p>
        <p>보존이유 : 통신비밀보호법</p>
        <p>보존기간 : 3개월</p> 
        <br/>
        <p id='pick'>■ 개인정보의 파기절차 및 방법</p>
        <p>회사는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체없이 파기합니다. 파기절차 및 방법은 다음과 같습니다. </p>
        <p>회원님이 입력하신 정보는 목적이 달성된 후 별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라(보유 및 이용기간 참조) 일정 기간 저장된 후 파기되어집니다. </p>
        <p>별도 DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 보유되어지는 이외의 다른 목적으로 이용되지 않습니다. </p>
        <p>• 파기방법</p>
        <p>전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다. </p>
        <br/>
        <p id='pick'>■ 개인정보 제공</p>
        <p>회사는 이용자의 개인정보를 원칙적으로 외부에 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다. </p>
        <p>• 이용자들이 사전에 동의한 경우</p>
        <p>• 법령의 규정에 의거하거나 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우</p>
        <br/>
        <p id='pick'>■ 수집한 개인정보의 위탁</p>
        <p>회사는 서비스 이행을 위해 아래와 같이 외부 전문업체에 위탁하여 운영하고 있습니다. </p>
        <p>• 위탁 대상자 : ［NHN한국 사이버 결제 주식회사］</p>
        <p>• 위탁업무 내용: ［상품 신용카드 결제］</p>
        <br/>
        <p id='pick'>■ 이용자 및 법정대리인의 권리와 그 행사방법</p>
        <p>• 이용자는 언제든지 등록되어 있는 자신의 개인정보를 조회하거나 수정할 수 있으며 가입해지를 요청할 수도 있습니다. </p>
        <p>• 개인정보관리책임자에게 서면, 전화 또는 이메일로 연락하시면 지체없이 조치하겠습니다. </p>
        <p>• 귀하가 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다. </p>
        <p>또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체없이 통지하여 정정이 이루어지도록 하겠습니다. </p>
        <p>• 회사는 이용자의 요청에 의해 해지 또는 삭제된 개인정보는 "회사가 수집하는 개인정보의 보유 및 이용기간"에 명신된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다. </p>
        <p>• 본 사이트는 만 14세 미만의 아동의 개인정보를 수집하지 않습니다. </p>
        <br/>
        <p id='pick'>■ 개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항</p>
        <p>회사는 귀하의 정보를 수시로 저장하고 찾아내는 "쿠키"등을 운용합니다. </p>
        <p>쿠키란 웹사이트를 운영하는데 이용되는 서버가 귀하의 브라우저에 보내는 아주 작은 텍스트 파일로서 귀하의 컴퓨터 하드디스크에 저장됩니다. </p>
        <p>회사는 다음과 같은 목적을 위해 쿠키를 사용합니다. </p>
        <p>• 쿠키 등 사용 목적 : 이용자가 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속 여부 등을 파악하여 이용자에게 최적화된 정보 제공을 위해 사용됩니다.  </p>
        <p>• 쿠키의 설치∙운영 및 거부 : 웹브라우저 상단의 도구>인터넷 옵션>개인정보 메뉴의 옵션 설정을 통해 쿠기 저장을 거부할 수 있습니다. </p>
        <p>• 쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다. </p>
        <br/>
        <p id='pick'>■ 개인정보에 관한 민원서비스 </p>
        <p>회사는 고객의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 아래와 같이 관련 부서 및 개인정보관리책임자를 지정하고 있습니다. </p>
        <p>• 개인정보관리담당자</p>
        <p>성명 : 한중민, 이지혜</p>
        <p>전화번호 : 1899-1777</p>
        <p>이메일 : yujinsojang@naver.com </p>
        <br/>
        <p>• 개인정보관리책임자</p>
        <p>성명 : 한종희, 박정호</p>
        <p>전화번호 : 1899-1777</p>
        <p>이메일 : yujinsojang@naver.com </p>
        <br/>
        <p>기타 개인정보 침해에 대한 신고나 상담이 필요한 경우에 아래 기관에 문의 가능합니다.</p>
        <p>• 개인정보침해신고센터 (privacy.kisa.or.kr / 국번없이 118)</p>
        <p>• 대검찰청 사이버수사과 (www.spo.go.kr / 국번없이 1301)</p>
        <p>• 경찰청 사이버수사국 (police.go.kr / 국번없이 182)</p>
      </div>

      </Modal>

      );
    };
return sessionLoginInfo !== null && (
  <ModalForm visible={modalOpen} />
);
}
}

export default InfoModal;